import { Button } from "@features/atoms/Button"
import { SiteLogo } from "./SiteLogo"
import { useAppState } from "@hooks/useAppState"
import { Link } from "eddev/routing"
import { motion, useMotionValueEvent, useScroll } from "motion/react"
import { useState } from "react"

export function Header() {
  const [state, setState] = useState<"top" | "collapsed" | "peek">("top")
  const { scrollY } = useScroll()

  useMotionValueEvent(scrollY, "change", (v) => {
    if (v < 20) {
      setState("top")
    } else if (scrollY.getVelocity() < 0) {
      setState("peek")
    } else {
      setState("collapsed")
    }
  })

  return (
    <motion.div initial="top" animate={state} className="fixed top-0 w-full z-30 pointer-events-none isolate">
      <motion.div
        variants={{ top: { opacity: 0 }, collapsed: { opacity: 0 }, peek: { opacity: 1 } }}
        className="absolute inset-x-0 -top-[50px] h-[130px] bg-black/80 blur-lg z-[-1]"
      ></motion.div>
      <div className="w-grid h-headerHeight xxl:w-full xxl:px-6 mx-auto grid grid-cols-3 items-center">
        <div className="flex justify-start gap-1">
          <MenuButton />
        </div>
        <motion.div
          variants={{ collapsed: { y: "-100%", opacity: 0, filter: "blur(20px)" } }}
          className="flex justify-center pointer-events-auto"
          transition={{ type: "spring", stiffness: 70, damping: 10 }}
        >
          <SiteLogo />
        </motion.div>
        <div className="flex justify-end">
          <Link href="/contact" className="pointer-events-auto">
            <Button variant="ghost">Contact</Button>
          </Link>
        </div>
      </div>
    </motion.div>
  )
}

function MenuButton() {
  const appState = useAppState()

  return (
    <Button
      variant="ghost"
      icon={HAMBURGER}
      className="pointer-events-auto"
      onClick={() => {
        if (appState.menuIsOpen) {
          appState.closeMenu()
        } else {
          appState.openMenu()
        }
      }}
    >
      Menu
    </Button>
  )
}

const HAMBURGER = (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="12" height="1" fill="currentColor" />
    <rect y="8.5" width="12" height="1" fill="currentColor" />
    <rect y="4.5" width="12" height="1" fill="currentColor" />
  </svg>
)
